export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40bd54b5ceff384760b1c56253166edb5358dc9095&name=revalidateCommunity!'